// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eoM5","col":"styles_col__2aDXk"};